import React, { useState } from 'react'
import { Fragment } from 'react'
import './tab.css'

/**
 * Tabs
 */
export const Tabs = (props) => {

  const { children, selected, onChange } = props

  const tabs = React.Children.map(children, (child, index) => {

    function select(id) {
      if (onChange) onChange(id || index)
    }

    return React.cloneElement(child, {
      selected: index === selected || selected === child.props.id,
      onSelect: select
    })
  })

  return (
    <div className="tabs">
      {tabs}
      <div className="tab-filler" />
    </div>
  )
}

/**
 * Tab
 */
export const Tab = (props) => {

  const { id, label, selected, actions, onSelect } = props

  function select() {
    if (onSelect) onSelect(id)
  }

  const style = selected ? "selected" : ""
  return (
    <div className={`tab ${style}`} onClick={select}>
      {label}
      {actions ? actions : null}
    </div>
  )
}

/**
 * Stack
 */
 export const Stack = (props) => {

  const { selected = 0 } = props

  const child = React.Children
    .toArray(props.children)
    .filter((child, index) => index === selected )[0]
  
  return (
    <Fragment>
      {child}
    </Fragment>
  )
}